import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../services/account.service';
import { ToastrService } from 'ngx-toastr';
import { BrandingService } from '../../services/branding.service';
import { HomeRouteService } from '../../services/home-route.service';
import { PageAccessStateService } from '../../services/page-access-state.service';
import { TenantFeaturesService } from '../../services/tenant-features.service';
import { BillingService } from '../../services/billing.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent {
  loginForm: FormGroup;
  showPassword: boolean = false;
  isLoading: boolean = false;
  readonly year = new Date().getFullYear();
  get loginformcontrols() {
    return this.loginForm.controls;
  }

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private toastr: ToastrService,
    public branding: BrandingService,
    private homeRoute: HomeRouteService,
    private pageAccess: PageAccessStateService,
    private tenantFeatures: TenantFeaturesService,
    private billing: BillingService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      rememberMe: [false],
    });
  }

  ngOnInit(): void {
    // Already signed in: go straight to this role's landing page.
    if (localStorage.getItem('authToken')) {
      this.homeRoute.resolve().subscribe((url) => this.router.navigateByUrl(url));
      return;
    }
    // Tenant is resolved (and validated to exist) by tenantResolveGuard before
    // this page activates, so no tenant lookup is needed here.
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    this.isLoading = true;
    this.accountService
      .login(
        this.loginformcontrols['email'].value,
        this.loginformcontrols['password'].value
      )
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response.isSuccess) {
            // A new user in this tab: drop whatever menu state an earlier session left behind
            // (e.g. a token that expired without a logout), so the guard and sidebar reload it.
            this.pageAccess.clear();
            this.tenantFeatures.clear();
            this.billing.clear();
            const returnUrl = this.route.snapshot.queryParams['returnUrl'];
            if (returnUrl) {
              this.router.navigateByUrl(returnUrl);
            } else {
              // No deep link to go back to: land on this role's home page (teachers on today's
              // lessons, parents on their children, everyone else on the dashboard).
              this.homeRoute.resolve().subscribe((url) => this.router.navigateByUrl(url));
            }
          } else {
            this.toastr.error(response.errors.join('\n'), 'Title');
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Login Failed:', error);
          this.toastr.error(
            error.error.errors.map((e: any) => e.messageEn).join('<br>'),
            'title'
          );
        },
      });
  }

  onForgotPassword() {
    // Handle forget password action
    console.log('Forgot password clicked');
  }
}
